import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { FastField, Field, useFormikContext } from "formik";
import { TextField } from "@mui/material";
import DropdownSelector from "../../atoms/Common/DropdownSelector.tsx";
import { getCatalogue } from "../../api/common/catalogues.ts";
import { LGNumber } from "../../atoms/Inputs/LGNumber.tsx";
import FacesSelector from "../../atoms/Inputs/FacesSelector.tsx";

export default function ProductPlasticosForm() {
  const { values, setFieldValue } = useFormikContext() as any;

  // Initialize props structure for PLASTICOS products
  useEffect(() => {
    if (!values.props || values.props.length === 0 || 
        !values.props.some(p => p?.key === "F" || p?.key === "NC" || p?.key === "A" || p?.key === "L" || p?.key === "E" || p?.key === "C" || p?.key === "S" || p?.key === "U")) {
      const props = [
        { key: "F", value: "" }, // Acabado
        { key: "NC", value: "" }, // Numero de caras
        { key: "A", value: "" }, // Ancho
        { key: "L", value: "" }, // Largo
        { key: "E", value: "" }, // Espesor
        { key: "C", value: "" }, // Color
        { key: "S", value: "" }, // Especificacion
        { key: "U", value: "" }, // Unidad de medida
      ];
      setFieldValue("props", props);
    }
  }, [setFieldValue, values.props]);

  // Update props.4.value whenever thickness or thickness_unit changes
  const handleThicknessChange = () => {
    const concatenatedValue = `${values.thickness || ""}${values.thickness_unit?.toUpperCase() || ""}`;
    setFieldValue("props.4.value", concatenatedValue);
  };

  useEffect(() => {
    handleThicknessChange();
  }, [values.thickness, values.thickness_unit]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FastField
          fullWidth
          name="props.0.value"
          label="Acabado"
          as={DropdownSelector}
          fetchFunction={getCatalogue}
          fetchParams={{ catalogueName: "PRODUCT_FINISH", pageSize: 1000 }}
          keyField="id"
        />
      </Grid>

      <Grid item xs={12}>
        <FacesSelector name="props.1.value" />
      </Grid>

      <Grid item xs={12}>
        <Field
          fullWidth
          name="props.2.value"
          label="Ancho (cm)"
          as={LGNumber}
          inputProps={{ step: "0.1" }}
        />
      </Grid>

      <Grid item xs={12}>
        <Field
          fullWidth
          name="props.3.value"
          label="Largo (cm)"
          as={LGNumber}
          inputProps={{ step: "0.1" }}
        />
      </Grid>

      <Grid item xs={6}>
        <Field
          fullWidth
          name="thickness"
          label="Espesor"
          as={LGNumber}
          inputProps={{ step: "0.1" }}
          onChange={(e) => {
            setFieldValue("thickness", e.target.value);
          }}
        />
      </Grid>

      <Grid item xs={6}>
        <FastField
          fullWidth
          name="thickness_unit"
          label="Unidad de Espesor"
          as={DropdownSelector}
          fetchFunction={getCatalogue}
          fetchParams={{ catalogueName: "UNIT", pageSize: 1000 }}
          keyField="code"
        />
      </Grid>

      <Grid item xs={12}>
        <FastField
          fullWidth
          name="props.5.value"
          label="Color"
          as={DropdownSelector}
          fetchFunction={getCatalogue}
          fetchParams={{ catalogueName: "PRODUCT_COLOR" , pageSize: 1000}}
          keyField="id"
        />
      </Grid>

      <Grid item xs={12}>
        <Field
          fullWidth
          name="props.6.value"
          label="Especificación"
          as={TextField}
        />
      </Grid>

      <Grid item xs={12}>
        <FastField
          fullWidth
          name="props.7.value"
          label="Unidad de medida"
          as={DropdownSelector}
          fetchFunction={getCatalogue}
          fetchParams={{ catalogueName: "UNIT", pageSize: 1000 }}
          keyField="id"
        />
      </Grid>
    </Grid>
  );
}

